import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import RH from '../../../components/rh/rh';


function HomeRHScreen () {
    return (
        <Fragment>
            <Head titulo="Área de RH | Consórcio LVF" />
            <Header />
            <RH />
            <Footer />
        </Fragment>
    );
}

export default HomeRHScreen;